import { render, staticRenderFns } from "./StudyLayout.vue?vue&type=template&id=5f4c9031&scoped=true&"
import script from "./StudyLayout.vue?vue&type=script&lang=js&"
export * from "./StudyLayout.vue?vue&type=script&lang=js&"
import style0 from "./StudyLayout.vue?vue&type=style&index=0&id=5f4c9031&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c9031",
  null
  
)

export default component.exports